import { h } from 'preact';
import { Header } from '@cube/blocks';
import { Text } from 'preact-i18n';
import Earnings from './earnings';
import { ProfilePhone } from '../company-profile';
import Footnotes from '../footnotes';
import cx from 'classnames';
import style from './style';

import StockDetails from '../stock-details';

const INTL_NS = 'statistics-panel';

const FOOTNOTES = [
	'marketCapSecurityStats',
	'trailingPe',
	'enterpriseValueRevenue',
	'enterpriseValueEbitda',
	'returnOnAssets',
	'returnOnEquity',
	'revenuePerShare',
	'quarterlyRevenueGrowth',
	'quarterlyEarningsGross',
	'payoutRatio'
].map((name) => (
	{
		name,
		text: <Text id={`${INTL_NS}.${name}`} />
	}
));

export default function KeyStatistics({ quote, width, showProfileInfo, class: className, ...props }) {
	return (
		<div class={cx(style.statistics, style.phone, className, width > 600 && style.wide)}>
			<div>
				<Earnings {...props} />
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.valuationMeasures`} />} />
				<StockDetails
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'marketCapSecurityStats',
						'enterpriseValue',
						'trailingPe',
						'priceToSale',
						'priceToBook',
						'enterpriseValueRevenue',
						'enterpriseValueEbitda'
					]}
				/>
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.financialHighlights`} />} />
				<StockDetails
					header={<Text id={`${INTL_NS}.managementEffectiveness`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'returnOnAssets',
						'returnOnEquity'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.incomeStatement`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'revenue',
						'revenuePerShare',
						'quarterlyRevenueGrowth',
						'grossProfit',
						'ebitda',
						'dilutedEps',
						'quarterlyEarningsGross'
					]}
				/>
			</div>
			<div class={cx(style.statistics)}>
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.tradingInformation`} />} />
				<StockDetails
					header={<Text id={`${INTL_NS}.stockPriceHistory`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'oneYearChange',
						'oneYearHigh',
						'oneYearLow',
						'oneWeekAvgVolume',
						'threeMonthAvgVolume',
						'sharesOutstanding'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.oneWeekPerformance`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'vsDowWeek',
						'vsSPWeek',
						'vsNasdaqWeek'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.oneYearPerformance`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'vsDowYear',
						'vsSPYear',
						'vsNasdaqYear'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.dividendInformation`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'trailingDividendRate',
						'trailingDividendYield',
						'payoutRatio'
					]}
				/>
			</div>
			<Footnotes class={style.footnotes} notes={FOOTNOTES} />
			{ showProfileInfo && <ProfilePhone {...props} />}
		</div>
	);
}
